import { InvestorEffects } from './effects/investor.effects';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import * as fromInvestor from 'src/app/store/investor/reducers/investor.reducers';
import { InvestorFacade } from './facade/investor.facade';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('investor', fromInvestor.InvestorReducer),
    EffectsModule.forFeature([InvestorEffects])
  ],
  providers: [InvestorFacade]
})
export class InvestorStoreModule {}

